(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name drug.factory:Drug
   *
   * @description
   *
   */
  angular
    .module('vcdrug')
    .factory('DrugInteraction', DrugInteraction);


  DrugInteraction.$inject = ['restmod'];

  function DrugInteraction(restmod) {
    return restmod.model('/routes/druginteractions').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true}
    });
  }

// klammerfriedhof
}());
